module.exports = window.React || window.require && window.require('react');